angular.module('leanlaw').directive('spinLoader', function () {
  return {
    restrict: 'E',
    transclude: true,
    template: '<div ng-class="{loading: isLoading}" ng-transclude ng-show="isLoading"></div>'
  };
});